module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 8-6310a6b5bb0dd7593243e54983ccb21a.jpg";